import React,{useContext} from "react";
import { View, StyleSheet, TouchableWithoutFeedback, TouchableOpacity, Text, TouchableHighlight, Image } from "react-native";
import connectionConfig from "../config/settings";
import colors from "../config/colors";
import { MaterialCommunityIcons, MaterialIcons, FontAwesome5, Ionicons} from "@expo/vector-icons";
//import useAuth from "../auth/useAuth";
import AuthContext from "../auth/context";

function CardFeedMenu({
                        typeButton,
                        onPress,
                      }) {
    //const { user } = useAuth();
    const { user, setUser } = useContext(AuthContext);
    let perfilUri, webUrl, seedVideoUri;
    if (connectionConfig.switchS3 === true) {
        //console.log('FeedScreen -> guarda las imagenes en un bucket de aws S3')
        perfilUri = connectionConfig.imageUrlS3
        webUrl = connectionConfig.imageUrlS3
        seedVideoUri = connectionConfig.imageUrlS3
        //debugger
    } else {
        console.log('else switchS3')
        perfilUri = connectionConfig.imageUrl + '/PerfilDeUsuario/'
        webUrl = connectionConfig.imageUrl + '/seedImages/'
        seedVideoUri = connectionConfig.imageUrl + '/Documents/videoSeeds/'
    }
      return (
      <View style={styles.card}
      >
                {
                    typeButton === 'search' ?
               <>
                    < MaterialIcons   
                        style={styles.iconCont} 
                        name="search"
                        size={40}
                        color={colors.green}
                        onPress={onPress}
                    />
                    <Text 
                    onPress={onPress}
                    style={styles.textCont}
                    >
                      Contenido
                    </Text>
                </>
                    :
                    typeButton === 'profile' ?
                <>
                    <TouchableHighlight
                        onPress={onPress}
                    >
                        <Image style={styles.image} source={{ uri: perfilUri + JSON.parse(user).userId + '_' + JSON.parse(user).userPhoto }}
                        />
                    </TouchableHighlight>
                    <Text 
                      style={styles.textPer} 
                      onPress={onPress} 
                    >
                      Perfil
                    </Text>
                </>
                    :
                    typeButton === 'history' ?
                <>
                    <FontAwesome5
                        style={styles.iconHist} 
                        name="history"
                        size={25}
                        color={colors.green}
                        onPress={onPress}>
                    </FontAwesome5>
                      <Text 
                      style={styles.textHist} 
                      onPress={onPress}
                      >
                        Historys
                      </Text>
                </>
                        :
                        typeButton === 'chat' ?
                <>
                        <FontAwesome5
                        style={styles.iconChat}
                        name="rocketchat"
                        size={25}
                        color={colors.green}                     
                        onPress={onPress}>
                         </FontAwesome5>
                        <Text 
                        style={styles.textChat}
                        onPress={onPress}
                        >
                          Chat
                        </Text>
                </>
                        :
                        typeButton === 'notUser' ?
                    <>
                      <Ionicons
                      style={styles.iconReg}
                        onPress={onPress}                        
                        name="create"
                        color={colors.green}
                        size={35}
                      />
                      <Text 
                      style={styles.textReg}
                      onPress={onPress}
                      >
                        Registrate
                      </Text>
                    </>
                      :
                        typeButton === 'quienSomos' ?
                    <TouchableOpacity onPress={onPress} style={{alignItems:'center', justifyContent:'center'}}>
                          <Image style={styles.image} source={require("../assets/fixdplanet1024.png")} />

                      {/* <Ionicons
                      style={styles.iconReg}
                        onPress={onPress}                        
                        name="create"
                        color={colors.green}
                        size={35}
                      /> */}
                      <Text 
                      style={styles.textReg}
                      onPress={onPress}
                      >
                        Quienes somos 
                      </Text>
                    </TouchableOpacity>
                                :
                                null
                }
      </View>

  );
}

const styles = StyleSheet.create({
  card: {
    borderRadius: 15,
    height:63,
    width:100,
  },
  detailsContainer: {
    padding: 20,
  },
  image: {
    marginTop: 2.,
    width: 35,
    height: 35,
    borderRadius: 35,
  },
  textCont: {
    color:colors.green,
    marginLeft:'10%',
    //marginTop:'2%'
  },
  textPer: {
    color:colors.green,
    marginLeft:'5%',
    marginTop:'5%'
  },
  textChat: {
    color:colors.green,
    marginTop:'10%'
  },
  textHist: {
    color:colors.green,
    marginTop:'1%'
  },
  iconCont: {
    marginLeft:'12%',
    marginTop:'1%' 
  },
  iconReg: {
    marginLeft:'12%',
    marginTop:'3%' 
  },
  textReg: {
    color:colors.green,
    //marginTop:'1%'
  },
 iconChat:{
  marginTop:'10%'
 },
  iconHist: {
    marginTop:'13%',
    marginLeft:'9%'
  },
});

export default CardFeedMenu;